import { render } from "./EventsView.vue?vue&type=template&id=3a680a35&scoped=true"
import script from "./EventsView.vue?vue&type=script&lang=js"
export * from "./EventsView.vue?vue&type=script&lang=js"

import "./EventsView.vue?vue&type=style&index=0&id=3a680a35&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a680a35"]])

export default __exports__